/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import type { OrganizationFetchResponse } from './OrganizationFetchResponse.types.tsx';

const RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS =
	'RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS';

export const productsJsmOrganizationDetailsResource: RouteResource<OrganizationFetchResponse> =
	createResource<OrganizationFetchResponse>({
		type: RESOURCE_TYPE_PRODUCT_JSM_ORGANIZATION_DETAILS,
		getKey: () => 'state',
		getDataLoader: () =>
			import(
				/* webpackChunkName: "async-resource-products-jsm-organization-details", jiraSpaEntry: "async-resource-products-jsm-organization-details" */ './organizationDetailFetch.tsx'
			),
	});
